export const RequiredMark = () => {
    return(
        <span style={{color: 'red'}}>*</span>
    )
}
